// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { RawMessage } from "@lib/messaging/RawMessage";
import { Socket } from "@lib/messaging/Socket";
import { IEventListener } from "@lib/utilities/IEventListener";

/**
 * Defines an API for an endpoint that has multiple socket connected to it and therefore requires a socket ID to determine where to send a message.
 */
export type MultiSocketEndpoint = {
  readonly socketType: "multi";
  readonly onDisconnect: IEventListener<(endpoint: MultiSocketEndpoint, socket: Socket) => void>;
  readonly onMessage: IEventListener<(endpoint: MultiSocketEndpoint, socket: Socket, id: string, rawMessage: RawMessage) => void>;
  getSocket(id: string): Nullable<Socket>;
  sendRawMessage(id: string, rawMessage: RawMessage): void;
};